import axios from 'axios';
/**
 * Realiza una solicitud HTTP GET con cabeceras y manejo de errores estándar.
 *
 * @param {string} url - URL completa del recurso a obtener.
 * @param {Object} customHeaders - Headers adicionales para la petición.
 * @returns {Promise<{ data: any, statusCode: number }>} Resultado de la petición con datos o error.
 */
export async function fetchJSON(url, customHeaders = {}, version) {
  let country = version;

  try {
    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
        ...customHeaders,
      },
      params: {
        ...(country === 'us' && {country})
      }
    });

    return {
      data: status === 200 ? data : [],
      statusCode: status,
    };
  } catch (error) {
    console.error(`Error al obtener ${url}:`, error.message || error);
    return {
      data: [],
      statusCode: error.response?.status || 500,
    };
  }
}

/**
 * Realiza una solicitud con fallback automático a URL de respaldo
 */
export async function fetchJSONWithFallback(primaryUrl, fallbackUrl, version, customHeaders = {}) {
  try {
    const result = await fetchJSON(primaryUrl, customHeaders, version);
    if (result.statusCode === 200) {
      return result;
    }
    return await fetchJSON(fallbackUrl, customHeaders, version);
  } catch {
    return await fetchJSON(fallbackUrl, customHeaders, version);
  }
}
